import "./Resources/CSS/Common.css";
import HomePage from "./Pages/HomePage";
import About from "./Pages/About";
import Careers from "./Pages/Careers";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Blog from "./Pages/Blog";
import Call from "./Pages/Call";
import Contact from "./Pages/Contact";
function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<HomePage />} style={{ background: "red" }} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/career" element={<Careers />} />
        <Route exact path="/blog" element={<Blog />} />
        <Route exact path="/call" element={<Call />} />
        <Route exact path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
